var _require = require('./date-utils'),
    isSameDay = _require.isSameDay;

module.exports = function shouldShowPostUpdateDate(post) {
  return Boolean(post.firstPublishedDate && post.lastPublishedDate && !isSameDay(post.firstPublishedDate, post.lastPublishedDate));
};